import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/shared/patterns/AppShell';
import { collectionsNav, COLLECTIONS_PORTAL_TITLE } from '@/domains/collections';

export const Route = createFileRoute('/_backoffice/collections')({
    component: () => (
        <AppShell title={COLLECTIONS_PORTAL_TITLE} nav={collectionsNav}>
            <Outlet />
        </AppShell>
    ),
});
